RivalIQ.apps.Admin.apps.Account.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.UnknownAccount = Marionette.ItemView.extend({
        template: '#adminAccountDetailsUnknownAccountTemplate'
    });
});
